module.exports = __webpack_public_path__ + "img/vue-js.4c038d52.png";